// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__XRAMl","footer":"ModalUpdate_footer__1Epu5"};